import React, { useState, useEffect, useRef } from 'react';
import { Col, Row } from "react-bootstrap";
import { withRFSToken } from '../../../../Services/axios';
import { ADDSTATION } from '../../../../Utils/conts';
import ApexCharts from 'react-apexcharts';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions';


const Dashboard = () => {

  const isMounted = useRef(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingNew, setIsLoadingNew] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const gridRef = useRef(null);
  const gridRef_new = useRef(null);
  const [gridData, setGridData] = useState([]);
  const [gridDatanew, setGridDatanew] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [gridSelect, setGridSelect] = useState([]);
  const handleAddToGrid = async () => {

    try {
      const res = await withRFSToken.post(ADDSTATION, {})
        .then(function (res) {
          // const innerData = res;
          console.log("🚀 ~ .then ~ innerData:", res)
          if (res.data.response_code == 200) {
            setModalShow(false);
          }
        });

    } catch (error) {
      console.error('Error sending request:', error);
    }

    // dispatch(addData(formData));
    // dispatch(fetchStationGridData());
    // setSelectedDropdownValue([]);

  };
  const [condSeries, setCondSeries] = useState([
    {
      name: 'ULD',
      data: []
    },
  ]);
  useEffect(() => {
    if (isMounted.current) return;

    setGridDatanew({ Active: {} });
    setIsLoading(false);
    setIsLoadingNew(false);
    setGridData({ Active: {} });

    isMounted.current = true;
  }, []);

  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {

    if (gridRef.current) {

      // var token = "Bearer " + localStorage.ULD;
      jqxCookieCall()
      const source = {
        datatype: 'json',
        type: 'POST',
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'station', type: 'string' },
          { name: 'type_code', type: 'string' },
          { name: 'min_stock', type: 'string' },
          { name: 'sortage', type: 'string' },
          { name: 'current_stock', type: 'string' },
        ],
        url: `${process.env.REACT_APP_RFS_URL}get-stock-data`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRef.current).jqxGrid('clearselection');
          window.$(gridRef.current).jqxGrid("updatebounddata", "filter");

        },
        beforeprocessing: function (data) {
          // source.totalrecords = data.TotalRows;
          if (data && data.response_data && data.response_data.under_stocked) {
            // Re-map it to expected structure
            source.totalrecords = data.response_data.under_stocked.length;
            data.Rows = data.response_data.under_stocked;
          }
          const condsData = [
            {
              x: 'Understock',
              y: data.response_data.total_under_stocked,
              fillColor: '#FF4444' // orange or choose from condcolors[1]
            },
            {
              x: 'Overstock',
              y: data.response_data.total_over_stock,
              fillColor: '#64C8FF' // red or choose from condcolors[0]
            }            
          ];

          setCondSeries([
            {
              name: "Stock",
              data: condsData
            }
          ]);

        },
        sort: function () {
          window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };

      const dataAdapter = new window.$.jqx.dataAdapter(source);
      console.log('dataAdapter', dataAdapter);

      const columns = [
        // { text: 'id', filtertype: 'textbox', datafield: 'id', width: '40%' },
        { text: 'Station', filtertype: 'textbox', datafield: 'station', width: '15%', cellclassname: '', },
        { text: 'Type', filtertype: 'textbox', datafield: 'type_code', width: '15%', cellclassname: '', },
        {
          text: 'Shortage', filtertype: 'textbox', datafield: 'sortage', width: '15%', cellclassname: '',
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            if (cellValue) {
              return '<div class="jqx-grid-cell-left-align under_stock"> ' + cellValue + ' </div>';
            }
          },
        },
        { text: 'Current Stock', filtertype: 'textbox', datafield: 'current_stock', width: '20%', cellclassname: '', },
        { text: 'Min. Allotment', filtertype: 'textbox', datafield: 'min_stock', width: '20%', cellclassname: '', },
      ];

      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: true,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        selectionmode: 'checkbox',
        pageable: false,
        pageSize: 10,
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,

      };

      window.$(gridRef.current).jqxGrid(gridOptions);
      window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

      window.$(gridRef.current).on('rowclick', (event) => {
        console.log('event', event);
        const args = event.args.row.bounddata;
        console.log('args', args);
        const sendRowId = gridData;
        // console.log("🚀 ~ window.$ ~ sendRowId:", sendRowId)
        // setSelectedRowData({ args, station_id: args.id });

        setShowDetails(true);
      });
      window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      // row selection by checkbox
      window.$(gridRef.current).on('rowselect', (event) => {
        console.log("🚀 ~ window.$ ~ event:00000000", event.args.row)

        if (event.args.row) {

          const selectedRow = event.args.row.id;

          if (!gridSelect.includes(selectedRow)) {
            setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
          }
          setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
        } else {
          // Handle "Select All" case
          // const allIds = planData.map(row => row.booking_id);
          // console.log("All IDs:", allIds);
          // setGridSelect(allIds);
          console.log("Select All triggered");
        }
      });
      // console.log('ggg', gridSelect);
      window.$(gridRef.current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.id;
          setGridSelect(prevSelection => prevSelection.filter(id => id !== unselectedRowId));
        } else {
          setGridSelect([]);
        }
      });
      // End row selection 

    }
  }, [gridData]);

  useEffect(() => {

    if (gridRef_new.current) {

      // var token = "Bearer " + localStorage.ULD;
      jqxCookieCall()
      const source = {
        datatype: 'json',
        type: 'POST',
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'station', type: 'string' },
          { name: 'type_code', type: 'string' },
          { name: 'overstock', type: 'string' },
          { name: 'current_stock', type: 'string' },
          { name: 'max_stock', type: 'string' },
        ],
        url: `${process.env.REACT_APP_RFS_URL}get-stock-data`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRef.current).jqxGrid('clearselection');
          window.$(gridRef.current).jqxGrid("updatebounddata", "filter");

        },
        beforeprocessing: function (data) {
          // source.totalrecords = data.TotalRows;
          if (data && data.response_data && data.response_data.over_stocked) {
            // Re-map it to expected structure
            source.totalrecords = data.response_data.over_stocked.length;
            data.Rows = data.response_data.over_stocked;
          }
          // setChartData(prev => ({
          //   ...prev,
          //   total_over_stock: data.response_data.total_over_stock,
          //   total_under_stocked: data.response_data.total_under_stocked
          // }));
        },
        sort: function () {
          window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };

      const dataAdapter = new window.$.jqx.dataAdapter(source);
      console.log('localdata', source.localdata)
      const columns = [
        // { text: 'id', filtertype: 'textbox', datafield: 'id', width: '40%' },
        { text: 'Station', filtertype: 'textbox', datafield: 'station', width: '15%', cellclassname: '', },
        { text: 'Type', filtertype: 'textbox', datafield: 'type_code', width: '15%', cellclassname: '', },
        {
          text: 'Overstock', filtertype: 'textbox', datafield: 'overstock', width: '15%', cellclassname: '',
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            if (cellValue) {
              return '<div class="jqx-grid-cell-left-align over_stock"> ' + cellValue + ' </div>';
            }
          },
        },
        { text: 'Current Stock', filtertype: 'textbox', datafield: 'current_stock', width: '20%', cellclassname: '', },
        { text: 'Max. Allotment', filtertype: 'textbox', datafield: 'max_stock', width: '20%', cellclassname: '', },
      ];

      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: true,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        selectionmode: 'checkbox',
        pageable: false,
        pageSize: 10,
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,

      };

      window.$(gridRef_new.current).jqxGrid(gridOptions);
      window.$(gridRef_new.current).find('.jqx-grid-column-header').css('background-color', 'white');

      window.$(gridRef_new.current).on('rowclick', (event) => {
        console.log('event', event);
        const args = event.args.row.bounddata;
        console.log('args', args);
        const sendRowId = gridDatanew;
        // console.log("🚀 ~ window.$ ~ sendRowId:", sendRowId)
        // setSelectedRowData({ args, station_id: args.id });

        setShowDetails(true);
      });
      window.$(gridRef_new.current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      // row selection by checkbox
      window.$(gridRef_new.current).on('rowselect', (event) => {
        console.log("🚀 ~ window.$ ~ event:00000000", event.args.row)

        if (event.args.row) {

          const selectedRow = event.args.row.id;

          if (!gridSelect.includes(selectedRow)) {
            setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
          }
          setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
        } else {
          // Handle "Select All" case
          // const allIds = planData.map(row => row.booking_id);
          // console.log("All IDs:", allIds);
          // setGridSelect(allIds);
          console.log("Select All triggered");
        }
      });
      // console.log('ggg', gridSelect);
      window.$(gridRef_new.current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.id;
          setGridSelect(prevSelection => prevSelection.filter(id => id !== unselectedRowId));
        } else {
          setGridSelect([]);
        }
      });
      // End row selection 

    }
  }, [gridDatanew]);

  const [condOptions, setCondOptions] = useState({
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false // This will hide the toolbar
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        columnWidth: '5%',
        endingShape: 'rounded',
        borderRadius: 4,
        borderRadiusApplication: 'end',
        borderRadiusWhenStacked: 'last',
        dataLabels: {
          position: 'top', // top, center, bottom
        },
      }
    },
    dataLabels: {
      enabled: true,
      offsetY: 0,
      offsetX: 35,
      formatter: (val) => {
        return val;
      },
      style: {
        fontSize: '12px',
        colors: ["#304758"]
      }
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: [ 'Understock', 'Overstock']
    },
    yaxis: {
      title: {
        text: ' '
      },
      labels: {
        style: {
          fontSize: '12',
          colors: ["#000"],
          fontWeight: 600,
        }
      }
    },
    fill: {
      opacity: 1,
      colors: [
        "rgba(255, 181, 95, 1)",
        "rgba(203, 140, 255, 1)",
        "rgba(99, 169, 255, 1)",
        'rgba(84, 202, 82, 1)',
        'rgba(255, 107, 107, 1)',
      ]
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " units";
        }
      }
    }
  });
  return (
    <div className="lcontent">
      <Row>
        <Col sm='4'>
          <div className='cartbox all_border mb-2'>
            <div className='new_chart'>
              <h3>Current ULD Stock Deviations</h3>
              <p>Total over or under allotment</p>
            </div>
            <ApexCharts
              options={condOptions}
              series={condSeries}
              type="bar"
              height={170}
            />
          </div>

          {/* <div className="cartbox all_border">
            <div class="new_chart">
              <h3>Understocked ULD Inventory</h3>
              <p>Below minimum set stock level</p>
            </div>
          </div> */}
        </Col>
        <Col sm='4'>
          <div className="cartbox all_border m_height">
            <div class="new_chart mb-2">
              <h3>Understocked ULD Inventory</h3>
              <p>Below minimum set stock level</p>
            </div>
            {!isLoading && <div ref={gridRef} className='staion_grid' ></div>}
          </div>
        </Col>
        <Col sm='4'>
          <div className="cartbox all_border m_height">
            <div class="new_chart mb-2">
              <h3>Overstocked ULD Inventory</h3>
              <p>Above maximum set stock levell</p>
            </div>
            {!isLoadingNew && <div ref={gridRef_new} className='staion_grid' ></div>}
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default Dashboard;